import notificationError from '@/utils/functions/notificationError';
import { useInfiniteQuery } from 'react-query';
import { DEFAULT_ROWS, DEFAULT_ORDER } from '..';
import { materialList } from './Material.service';
import { MaterialListRequest } from './Material.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const QUERY_KEY = 'mails/workorder';

export function useMaterialList(params?: MaterialListRequest) {
  return useInfiniteQuery(
    [QUERY_KEY, params],
    ({ pageParam }) =>
      materialList({
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      }),
    {
      enabled: hasPermissions([Authorities.MOVIMENTATION_MATERIAL_VIEW]),
      getNextPageParam: (lastPage) => lastPage.result.nextToken,
      onError(error) {
        notificationError(error, {
          message: 'Listagem de materiais',
          description: 'Não foi possível listar os materiais.',
        });
      },
    },
  );
}
